// extracted by mini-css-extract-plugin
export var radioInputRow = "B_tF";
export var radioInputColumn = "B_tG";
export var inputOptionRow = "B_qC";
export var inputOptionColumn = "B_qD";